import { SearchContextProvider } from '../Contexts/SearchContext';
import SearchContainer from './SearchContainer';

const CustomerSuccessStories = props =>
  <SearchContextProvider>
    <SearchContainer {...props}/>
  </SearchContextProvider>;

export default CustomerSuccessStories;
